import { useContext } from 'react';

import FeatureGatesContext from 'contexts/FeatureGatesContext';

// A browser can ask for one library whatever the account's gate says (for
// testing): localStorage studioChartRenderer = 'echarts' or 'highcharts'
export const RENDERER_STORAGE_KEY = 'studioChartRenderer';

// The chart types ECharts draws so far. Everything else stays on
// Highcharts.
const ECHARTS_GADGET_TYPES: GadgetType[] = [
  'bar',
  'horizontalBar',
  'combo',
  'timeSeries',
  'stackedBar',
  'stackedArea',
  'pie',
  'donut',
  'funnel',
  'pyramid',
  'treeMap',
  'radar',
  'scatter',
  'bubble',
  'heatmap',
  'waterfall',
  'sankey',
  'packedBubble',
  'bullet',
];

// Drawn with ECharts whatever the gate says: Highcharts has no drawing of
// them (a Bullet's rows each have their own target and bands)
const ECHARTS_ONLY_GADGET_TYPES: GadgetType[] = ['bullet'];

const readRendererOverride = (): 'echarts' | 'highcharts' | undefined => {
  try {
    const renderer = window.localStorage.getItem(RENDERER_STORAGE_KEY);
    return renderer === 'echarts' || renderer === 'highcharts'
      ? renderer
      : undefined;
  } catch (ex) {
    return undefined;
  }
};

// Whether Studio draws its charts with ECharts: where the account's
// studio gate is on (staff included only there), unless the browser asks
// otherwise
export const useIsEChartsRenderer = (): boolean => {
  const { isStudioEnabled } = useContext(FeatureGatesContext);
  const override = readRendererOverride();
  return override ? override === 'echarts' : isStudioEnabled;
};

export const canDrawWithECharts = (chartDefinition: V5ChartDefinition) =>
  ECHARTS_GADGET_TYPES.includes(chartDefinition.gadgetType);

export const isDrawnOnlyWithECharts = (chartDefinition: V5ChartDefinition) =>
  ECHARTS_ONLY_GADGET_TYPES.includes(chartDefinition.gadgetType);
